const css = `.fZ-wYW__overlay{pointer-events:none;position:absolute;inset:0;overflow:hidden}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"overlay":"fZ-wYW__overlay"};
